// Creating I18n multilanguage object. Dashboard in Spanish and English
export const messages = { 
       en: {
            h1Login: 'Technology Operations',
            h2Login: 'Enter your Login Credentials',
            signInButton: 'Sign in',
            alarms: 'Alarms',
            alarmsNetwork: 'Alarms Network',
            alarmsIT: 'Alarms IT',
            history: 'History',
            registerEmail: 'user email',
            dashboard: 'Active Incidents',
            dashboardNetwork: 'Network Active Incidents',
            dashboardIT: 'IT Active Incidents',
            dashboardUsers: 'Users management',
            incidenceSearch: 'Incident search',
            incidenceSearchTitle: 'Incident Search',
            reportButton: 'Generate Report',
            myProfile: 'My profile',
            dataSavedAlert: 'Data succesfully saved',
            Edit: 'Edit:',
            UpdateAlarmRemember: 'Alarm list update paused',
            alarmsSummary: 'Alarms Summary',
            totalAlarmas: 'Total Active Alarms: ',
            totalAlarmasRed: 'Total Active Network Alarms: ', 
            totalAlarmasIT: 'Total Active IT Alarms: ',
            searchByIdentifier: 'Search by identifier',
            searchPlaceholder: 'Type INC/OCEANE identifier',
            searchType: 'Search type',
            includeErrors: 'Include errors',
            searchButton: 'Search',
            prevPage: 'Previous',
            nextPage: 'Next',
            noSearchResults: 'No incidents found',
            loadingSearch: 'Searching incidents...',
            searchError: 'Error searching incidents',
            colIncId: 'INC ID',
            colOceaneId: 'OCEANE ID',
            colType: 'Type',
            colAffectedService: 'Affected service',
            colTicketDate: 'Ticket date',
            colChannel: 'Channel',
            colMessageDate: 'Message date',
            colErrorCount: 'Errors',
            colActions: 'Actions',
            viewDetail: 'View detail',
            detailTitle: 'Search result details',
            latestCommunication: 'Latest communication',
            communicationHistory: 'Communication history',
            fieldId: 'ID',
            fieldChannel: 'Channel',
            fieldType: 'Type',
            fieldTicketDate: 'Ticket date',
            fieldMessageDate: 'Message date',
            fieldTitle: 'Title',
            fieldAffectedService: 'Affected service',
            fieldAffectedEquipment: 'Affected equipment',
            fieldImpact: 'Impact',
            fieldResponsible: 'Responsible',
            fieldActions: 'Actions',
            fieldOriginalMessage: 'Original message',
            fieldScaleLevel: 'Severity',
            noCommunicationHistory: 'No previous communications for this incident.',
            showMessage: 'Show message',
            hideMessage: 'Hide message',
            errorsBlock: 'Related errors',
            noRelatedErrors: 'No related errors for this incident.',
            fieldErrorService: 'Service',
            fieldErrorDate: 'Date',
            fieldErrorReason: 'Failure detected',
            fieldErrorMessage: 'Error message',
            fieldMissingFields: 'Missing fields',
        },
        es: {
            h1Login: 'Technology Operations',
            h2Login: 'Introduce tus datos de Acceso',
            signInButton: 'Autentícate',
            dashboard: 'Incidencias activas',
            dashboardNetwork: 'Incidencias activas Red',
            dashboardIT: 'Incidencias activas IT',
            dashboardUsers: 'Permisos de usuarios',
            incidenceSearch: 'Buscador incidencias',
            incidenceSearchTitle: 'Buscador de incidencias',
            alarms: 'Incidencias Red/IT',
            alarmsNetwork: 'Incidencias Red',
            alarmsIT: 'Incidencias IT',
            history: 'Histórico',
            registerEmail: 'email del usuario',
            reportButton: 'Generar informe',
            myProfile: 'Mi perfil',
            dataSavedAlert: 'Datos guardados correctamente',
            Edit: 'Editar:',
            UpdateAlarmRemember: 'Actualización de alarmas pausada',
            alarmsSummary: 'Resumen de Alarmas',
            totalAlarmas: 'Alarmas totales activas: ',
            totalAlarmasRed: 'Total de alarmas activas de Red: ', 
            totalAlarmasIT: 'Total de alarmas activas de IT: ',
            searchByIdentifier: 'Buscar por identificador',
            searchPlaceholder: 'Escribe identificador INC/OCEANE',
            searchType: 'Tipo de busqueda',
            includeErrors: 'Incluir errores',
            searchButton: 'Buscar',
            prevPage: 'Anterior',
            nextPage: 'Siguiente',
            noSearchResults: 'No se encontraron incidencias',
            loadingSearch: 'Buscando incidencias...',
            searchError: 'Error buscando incidencias',
            colIncId: 'ID INC',
            colOceaneId: 'ID OCEANE',
            colType: 'Tipo',
            colAffectedService: 'Servicio afectado',
            colTicketDate: 'Fecha ticket',
            colChannel: 'Canal',
            colMessageDate: 'Fecha mensaje',
            colErrorCount: 'Errores',
            colActions: 'Acciones',
            viewDetail: 'Ver detalle',
            detailTitle: 'Detalle del resultado',
            latestCommunication: 'Última comunicación',
            communicationHistory: 'Historial de comunicaciones',
            fieldId: 'ID',
            fieldChannel: 'Canal',
            fieldType: 'Tipo',
            fieldTicketDate: 'Fecha ticket',
            fieldMessageDate: 'Fecha mensaje',
            fieldTitle: 'Título',
            fieldAffectedService: 'Servicio afectado',
            fieldAffectedEquipment: 'Equipamiento afectado',
            fieldImpact: 'Impacto',
            fieldResponsible: 'Responsable',
            fieldActions: 'Acciones',
            fieldOriginalMessage: 'Mensaje original',
            fieldScaleLevel: 'Severidad',
            noCommunicationHistory: 'No hay comunicaciones anteriores para esta incidencia.',
            showMessage: 'Ver mensaje',
            hideMessage: 'Ocultar mensaje',
            errorsBlock: 'Errores relacionados',
            noRelatedErrors: 'No hay errores relacionados para esta incidencia.',
            fieldErrorService: 'Servicio',
            fieldErrorDate: 'Fecha',
            fieldErrorReason: 'Fallo detectado',
            fieldErrorMessage: 'Mensaje de error',
            fieldMissingFields: 'Campos faltantes',
        }
    };

export var defaultLocale = 'es'